"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setForceResolveState')(function setForceResolveState(viewstate, inForceResolve) {
    viewstate.inForceResolve = inForceResolve;
});
//# sourceMappingURL=setForceResolveState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setForceResolveState.js
// module id = 2755
// module chunks = 2 3 4 45